import React from "react";
import styled from "styled-components";
import { Link } from "gatsby";

import LevelBar from "./LevelBar";
import MetricBar from "./MetricBar";

import iconCloudHostingemail from "../images/homepage/ico-cloud-hostingemail.svg";
import iconOpenclooud from "../images/homepage/ico-openclooud.svg";
import iconManagedCloudserver from "../images/homepage/ico-managed-cloudserver.svg";
import iconMulticloudManagedService from "../images/homepage/ico-multicloud-managed-service.svg";

const StoragePlanCompareChart = styled.div`
  display: block;
  width: 100% !important;
  margin-top: 55px !important;
  /* padding: 0 17px; */
`;

const Chart = styled.div`
  overflow: hidden;
  overflow-x: scroll;
  margin: 30px 0;
  .header__container {
    position: absolute;
    padding: 0;
    margin: 0;
    > div {
      box-sizing: border-box;
      position: absolute;
      width: 80px;
      height: 336px;
      background: #fff;
      border: 1px solid #efefef;
      padding: 88px 10px 73px 17px;
      box-shadow: 4px 4px 10px #efefef;
      z-index: 9;
      .header {
        list-style: none;
        font-size: 10px;
        line-height: 15px;
        color: #6c6c6c;
        &.usage {
          /* margin-top: 17px; */
        }
        &.traffic {
          margin-top: 17px;
        }
        &.power {
          margin-top: 17px;
        }
        &.scalability {
          margin-top: 17px;
        }
        &.resources {
          margin-top: 17px;
        }
        &.support {
          margin-top: 17px;
        }
      }
    }
  }
  .compare__list {
    display: inline-flex;
    margin: 0 0 0 80px;
    padding: 0;
    .compare__item {
      box-sizing: border-box;
      width: 150px;
      height: 336px;
      display: flex;
      flex-direction: column;
      border: 1px solid #efefef;
      border-left: none;
      padding: 12px 20px 24px 20px;
      position: relative;
      > div {
        /* display: grid; */
        color: #6c6c6c;
        position: relative;
      }
      .product {
        height: 75px;
        font-size: 12px;
      }
      .usage {
        font-size: 12px;
        line-height: 18px;
        height: 24px;
      }
      .traffic {
        margin-top: 13px;
      }
      .power {
        margin-top: 18px;
      }
      .scalability {
        margin-top: 25px;
      }
      .resources {
        font-size: 10px;
        line-height: 15px;
        margin-top: 25px;
      }
      .support {
        font-size: 10px;
        line-height: 15px;
        margin-top: 16px;
      }
      .viewmore {
        position: absolute;
        bottom: 20px;
      }
    }
  }

  @media screen and (min-width: 415px) {
    margin: 30px auto;
    overflow-x: auto;
    display: flex;
    flex-direction: row;
    justify-content: center;
    .header__container {
      position: relative;
      > div {
        border: none;
        width: 130px;
        height: 350px;

        box-shadow: none;
        position: relative;
        .header {
          font-size: 14px;
          line-height: 21px;
          &.usage {
            margin-top: 25px;
          }
        }
      }
    }
    .compare__list {
      margin: 0;
      .compare__item {
        border: none;
        height: 405px;
        width: 245px;
        .product {
        }
        .usage {
          font-size: 14px;
          line-height: 21px;
          margin-top: 25px;
        }
        .traffic {
          margin-top: 17px;
        }
        .power {
          margin-top: 25px;
        }
        .scalability {
          margin-top: 35px;
        }
        .resources {
          font-size: 14px;
          line-height: 21px;
        }
        .support {
          font-size: 14px;
          line-height: 21px;
        }
        .viewmore {
          bottom: 25px;
        }
      }
    }
  }
`;

const ChartTitle = styled.div`
  font-weight: 300;
  font-size: 18px;
  text-align: center;
  color: #2a3a91;
  position: relative;
  z-index: 1;

  span {
    z-index: 1;
    background: white;
    padding: 0px 80px;
    @media screen and (max-width: 414px) {
      width: 220px;
      display: block;
      margin: auto;
      padding: 0;
    }
  }

  ::after {
    content: "";
    border-top: 1px solid #2a3a91;
    margin: 0 auto;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    z-index: -1;
  }
`;

const PlanTypeTitle = styled.div`
  font-weight: 300;
  font-size: 12px;
  line-height: 14px;
  /* width: 85px; */
  color: #2a3a91;
  @media screen and (min-width: 415px) {
    margin-top: 15px;
    font-size: 18px;
    line-height: 21px;
    width: 160px;
  }
`;

const ViewMoreBtn = styled.a`
  width: 84px;
  height: auto;
  line-height: 14px;
  padding: 5px 10px;
  font-weight: 500;
  background: #c4c4c4;
  border-radius: 3px;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  &:hover,
  &.active {
    background: #2a3795;
  }
  @media screen and (min-width: 415px) {
    width: 120px;
    height: 36px;
    line-height: normal;
    padding: 8px 19px;
    font-weight: bold;
  }
`;

function ProductCompareTable(props) {
  const { lng, t, hostname } = props;
  return (
    <StoragePlanCompareChart>
      <ChartTitle>
        <span>{t["storageCompChart.title"]}</span>
      </ChartTitle>
      <Chart>
        <ul className="header__container">
          <div>
            <li className="header usage">
              {t["storageCompChart.usage.title"]}
            </li>
            <li className="header traffic">
              {t["storageCompChart.traffic.title"]}
            </li>
            <li className="header power">
              {t["storageCompChart.power.title"]}
            </li>
            <li className="header scalability">
              {t["storageCompChart.scale.title"]}
            </li>
            <li className="header resources">
              {t["storageCompChart.resources.title"]}
            </li>
            <li className="header support">
              {t["storageCompChart.support.title"]}
            </li>
          </div>
        </ul>
        <ul className="compare__list">
          <li className="compare__item">
            <div className="product">
              <img
                src={iconCloudHostingemail}
                alt="Cloud Web Hosting & Email | UD Cloud Service"
              />
              <PlanTypeTitle>{t["storageCompChart.hosting"]}</PlanTypeTitle>
            </div>
            <div className="usage">{t["storageCompChart.usage.hosting"]}</div>
            <div className="traffic">
              <LevelBar percentage={30} />
            </div>
            <div className="power">
              <MetricBar percentage={50} />
            </div>
            <div className="scalability">
              <MetricBar percentage={50} />
            </div>
            <div className="resources">
              {t["storageCompChart.resources.shared"]}
            </div>
            <div className="support">
              {t["storageCompChart.support.selfmanage"]}
            </div>
            <div className="viewmore">
              <ViewMoreBtn
                href={`https://${hostname}/${lng}/service/cloud-hosting/hongkong`}
                data-cta="See-Pricing"
                className="active"
              >
                {t["storageCompChart.seePricing"]}
              </ViewMoreBtn>
            </div>
          </li>
          <li className="compare__item">
            <div className="product">
              <img
                src={iconOpenclooud}
                alt="OpenCloud | UD Cloud Service"
              />
              <PlanTypeTitle>{t["storageCompChart.opencloud"]}</PlanTypeTitle>
            </div>
            <div className="usage">{t["storageCompChart.usage.opencloud"]}</div>
            <div className="traffic">
              <LevelBar percentage={80} />
            </div>
            <div className="power">
              <MetricBar percentage={100} />
            </div>
            <div className="scalability">
              <MetricBar percentage={100} />
            </div>
            <div className="resources">
              {t["storageCompChart.resources.dedicated"]}
            </div>
            <div className="support">
              {t["storageCompChart.support.selfmanage"]}
            </div>
            <div className="viewmore">
              <ViewMoreBtn
                href={`https://${hostname}/${lng}/service/opencloud-server-openstack-instant-setup-asia-hongkong`}
                data-cta="See-Pricing"
              >
                {t["storageCompChart.seePricing"]}
              </ViewMoreBtn>
            </div>
          </li>
          <li className="compare__item">
            <div className="product">
              <img
                src={iconManagedCloudserver}
                alt="Managed Cloud Server | UD Cloud Service"
              />
              <PlanTypeTitle>{t["storageCompChart.cloud"]}</PlanTypeTitle>
            </div>
            <div className="usage">{t["storageCompChart.usage.cloud"]}</div>
            <div className="traffic">
              <LevelBar percentage={80} />
            </div>
            <div className="power">
              <MetricBar percentage={100} />
            </div>
            <div className="scalability">
              <MetricBar percentage={80} />
            </div>
            <div className="resources">
              {t["storageCompChart.resources.dedicated"]}
            </div>
            <div className="support">
              {t["storageCompChart.support.engineersupport"]}
            </div>
            <div className="viewmore">
              <ViewMoreBtn
                href={`https://${hostname}/${lng}/service/cloud-server`}
                data-cta="See-Pricing"
              >
                {t["storageCompChart.seePricing"]}
              </ViewMoreBtn>
            </div>
          </li>
          <li className="compare__item">
            <div className="product">
              <img
                src={iconMulticloudManagedService}
                alt="Managed Multi-Cloud Solution | UD Cloud Service"
              />
              <PlanTypeTitle>{t["storageCompChart.multicloud"]}</PlanTypeTitle>
            </div>
            <div className="usage">
              {t["storageCompChart.usage.multicloud"]}
            </div>
            <div className="traffic">
              <LevelBar percentage={80} />
            </div>
            <div className="power">
              <MetricBar percentage={80} />
            </div>
            <div className="scalability">
              <MetricBar percentage={80} />
            </div>
            <div className="resources">
              {t["storageCompChart.resources.dedicated"]}
            </div>
            <div className="support">
              {t["storageCompChart.support.engineersupport"]}
            </div>
            <div className="viewmore">
              <ViewMoreBtn
                href={`https://${hostname}/${lng}/solution/managed-multi-cloud-solution-one-platform`}
                data-cta="See-Pricing"
              >
                {t["storageCompChart.viewSolution"]}
              </ViewMoreBtn>
            </div>
          </li>
        </ul>
      </Chart>
    </StoragePlanCompareChart>
  );
}

export default ProductCompareTable;
